import { render, staticRenderFns } from "./goodsFiles.vue?vue&type=template&id=4a67b5f6&scoped=true"
import script from "./goodsFiles.vue?vue&type=script&lang=js"
export * from "./goodsFiles.vue?vue&type=script&lang=js"
import style0 from "./goodsFiles.vue?vue&type=style&index=0&id=4a67b5f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a67b5f6",
  null
  
)

export default component.exports